function lobbyLoginReducer(state = {}, action = {}) {
  switch (action.type) {
    case 'STORE_PATIENT_QUESTIONNAIRE_DUE_READ_ALL':
      const questionnaire = action.result
      let questions = []

      questionnaire.forEach((questionnaire, idx) => {
        questions = questions.concat(questionnaire.questions.map(question => {
          return {...question, questionnaire_id: questionnaire.questionnaire_id}
        }))
      })

      return {
        ...state,
        questionnaire: questions
      }
    case 'STORE_LOGIN/NEWPATIENT_CREATE':
      return {
        ...state,
        manualLogin: action.result
      }
    case 'STORE_PATIENT_ANSWER_CREATE':
      return {
        ...state,
        patientAnswers: action.result
      }
    case 'STORE_LOGIN_CREATE':
    case 'STORE_LOGOUT_CREATE':
      return {
        ...state,
        // clear any questionnaire data left over from a previous session
        // so the kiosk QuestionnairePanel always re-fetches fresh data
        // instead of latching onto stale questions.
        questionnaire: null,
        patientAnswers: null,
        lobbyPatient: action.result
      }
    case 'RESET_LOGIN':
      return {
        ...state,
        questionnaire: null,
        patientAnswers: null,
        manualLogin: null,
        lobbyPatient: null
      }
    default:
      return state
  }
}

export default lobbyLoginReducer
